import { ICreateQuote } from '../../../../constants/interfaces';
import { validateEmail } from '../../../../utils/validation/validation';

export const validateDataToSend = (
  dataToSend: ICreateQuote,
  setError: (v: string) => void
) => {
  const { firstName, lastName, email, phone, companyName, interested } =
    dataToSend;

  if (!firstName) {
    setError('Please enter your first name.');
    return false;
  }
  if (firstName.length > 15) {
    setError('First name can not be more than 15 characters.');
    return false;
  }

  if (!lastName) {
    setError('Please enter your last name.');
    return false;
  }

  if (lastName.length > 15) {
    setError('Last name can not be more than 15 characters');
    return false;
  }

  if (!email) {
    setError('Please enter your email.');
    return false;
  }

  if (email.length > 50) {
    setError('Email can not be more than 50 characters');
    return false;
  }

  if (!validateEmail(email)) {
    setError('Please enter e valid email address');
    return false;
  }

  if (!phone) {
    setError('Please enter your phone.');
    return false;
  }

  if (phone.length > 30) {
    setError('Phone can not be more than 30 characters');
    return false;
  }

  if (!companyName) {
    setError('Please enter your company name.');
    return false;
  }

  if (companyName.length > 50) {
    setError('Company Name can not be more than 50 characters');
    return false;
  }

  if (!interested) {
    setError('Please enter your interested zones.');
    return false;
  }

  if (interested.length > 1000) {
    setError('Interested text can not be more than 1000 characters');
    return false;
  }

  return true;
};
